/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import moment from 'moment';

let PluginCounter = new function(){
    var me = this;

    this.init = function(obj){
        obj.find('[data-plugin-counter]').each(function(){
            var el = $(this);
            var options = el.data('plugin-counter');

            var defaults = {
                prefixZero: false,
                end: 0
            };

            var settings = $.extend({}, defaults, options);

            var interval = setInterval(function(){
                var allSeconds = settings.end - moment().unix();
                if(allSeconds<0){
                    clearInterval(interval);
                    return;
                }

                var day = Math.floor(allSeconds/(3600*24));
                var hour = Math.floor((allSeconds-day*3600*24)/3600);
                var minute = Math.floor((allSeconds-day*3600*24-hour*3600)/60);
                var second = allSeconds-day*3600*24-hour*3600-minute*60;

                // day = ((day<10?'0':'')+day+'');
                // hour = ((hour<10?'0':'')+hour+'');
                // minute = ((minute<10?'0':'')+minute+'');
                // second = ((second<10?'0':'')+second+'');

                el.find('.part-days .counter-value').html(day);
                el.find('.part-hours .counter-value').html(hour);
                el.find('.part-minutes .counter-value').html(minute);
                el.find('.part-seconds .counter-value').html(second);
            }, 1000);
        });
    };
};

export default PluginCounter;
